import {
  CLOSE_SPLIT_SCREEN_TAKEOVER,
  OPEN_SPLIT_SCREEN_TAKEOVER,
} from 'constants/actions';

const splitScreenTakeovers = (state = null, action) => {
  switch (action.type) {
    case OPEN_SPLIT_SCREEN_TAKEOVER:
      return action.payload;
    case CLOSE_SPLIT_SCREEN_TAKEOVER:
      return null;
    default:
      return state;
  }
};

export default splitScreenTakeovers;
